'use client';
import { useState } from 'react';
import { Menu } from 'lucide-react';
import AppSidebar from '@/components/layout/AppSidebar';
import AuthGuard from '@/components/layout/AuthGuard';
import { PolicyAcceptanceDialog } from '@/components/gdpr/PolicyAcceptanceDialog';

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <AuthGuard>
      <div className="flex h-screen overflow-hidden">
        <AppSidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
        <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
          <header className="flex items-center h-12 px-4 border-b bg-background shrink-0 gap-3">
            <button
              onClick={() => setCollapsed((v) => !v)}
              className="p-1 rounded hover:bg-accent transition-colors"
            >
              <Menu className="size-4" />
            </button>
          </header>
          <main className="flex-1 overflow-y-auto p-6">
            {children}
          </main>
        </div>
        <PolicyAcceptanceDialog />
      </div>
    </AuthGuard>
  );
}
